
var Poll = function( pollID ) {
    'use strict';

    if ( ! pollID ) throw 'pollID required';

    var poll = this;
    var statusURL = '/voting/status/' + pollID;
    var votesURL  = '/voting/votes/'  + pollID;
    var voteURL   = '/voting/vote/'   + pollID;

    var canVoteRequest = false;
    poll.canVote = function( callback ) {
        if ( ! callback ) throw 'callback required';

        if ( canVoteRequest ) canVoteRequest.abort();
        canVoteRequest = $.ajax( statusURL, {
            'type'     : 'GET',
            'dataType' : 'json'
        } )
        .done( function( data ) {
            if ( data.success ) {
                if ( data.canVote ) callback( true );
                else                callback( false );
            }
            else {
                callback( false );
                console.trace( data.error );
            }
        } )
        .fail( function() {
            callback( false );
        } );
    };

    var getResultsRequest = false;
    poll.getResults = function( callback ) {
        if ( ! callback ) throw 'callback required';

        if ( getResultsRequest ) getResultsRequest.abort();
        getResultsRequest = $.ajax( votesURL, {
            'type'     : 'GET',
            'dataType' : 'json'
        } )
        .done( function( data ) {
            if ( data.success ) {
                callback( data.counts );
            }
            else {
                callback( [] );
                console.trace( data.error );
            }
        } )
        .fail( function() {
            callback( [] );
        } );
    };

    var submitVoteRequest = false;
    poll.submitVote = function( vote, callback ) {
        if ( ! vote ) throw 'vote required';
        if ( ! callback ) throw 'callback required';

        if ( submitVoteRequest ) submitVoteRequest.abort();
        submitVoteRequest = $.ajax( voteURL, {
            'type'     : 'POST',
            'dataType' : 'json',
            'data'     : { 'vote' : vote }
        } )
        .done( function( data ) {
            if ( data.success ) {
                callback( true );
            }
            else {
                callback( false );
                console.trace( data.error );
            }
        } )
        .fail( function() {
            callback( false );
        } );
    };
};

